var map = {
	"./best-app-development-tool.md": [
		98,
		3
	],
	"./common-misconceptions-about-payment.md": [
		99,
		4
	],
	"./things-to-know-about-startup-business.md": [
		100,
		5
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 95;
module.exports = webpackAsyncContext;